export class DocumentItemKeyData {
    public documentItemKeyTypeId: number;
    public itemKeyId: number;
}
